import React from "react";
import { Col } from "react-bootstrap";
import SelectDropDown from "../selectDropdown/SelectDropdown";
import ProductTagList from "./ProductTagList";
import { getAllDefaultTags } from "../../utility";

const ProductConditionTagSelector = ({
  productConditionList = [],
  selectedCondition,
  setSelectedCondition,
  productTags = [],
  selectedTags = [],
  setSelectedTags,
  handleSelectedTagsChange,
}) => {
  return (
    <>
      <Col md={12} className="px-0 mt-2">
        <p className="p-0">Select Condition/Tags:</p>
      </Col>
      <Col md={6} className="px-0">
        <SelectDropDown
          label="Condition"
          menuPortalTarget={""}
          menuPlacement={"bottom"}
          options={productConditionList}
          value={selectedCondition}
          handleChange={setSelectedCondition}
        />
      </Col>
      <Col md={12} className="px-0 mt-3">
        <div className="trade-in-item-tag-wrapper p-3">
          <Col md={12} className="pricing-Text p-0">
            Tags({selectedTags?.length || 0}):
          </Col>
          <ProductTagList
            isShowLabel={false}
            className={"d-flex flex-column align-items-start mt-3"}
            tagsList={getAllDefaultTags(productTags)}
            suggestedArrayList={productTags}
            onSelectTagsChange={handleSelectedTagsChange}
            customProductTags={true}
            productDetail={{
              tags: [
                ...selectedTags?.map((tag, index) => ({
                  id: index,
                  label: tag,
                  selected: true,
                })),
                ...getAllDefaultTags(productTags)
                  .filter((defaultTag) => !selectedTags.includes(defaultTag))
                  .map((defaultTag, index) => ({
                    id: index + selectedTags.length, // Adjusting ID to ensure it doesn't overlap
                    label: defaultTag,
                    selected: false,
                  })),
              ],
            }}
          />
        </div>
      </Col>
    </>
  );
};

export default ProductConditionTagSelector;
